/* assets/featured-collection-init.js */
(function () {
  // Registra el módulo para el boot genérico
  window.__SectionRegistry = window.__SectionRegistry || {};

  // Utilidad: espera a GSAP + ST (NO exigimos lenis)
    function libsReady() {
    return !!(window.gsap && window.ScrollTrigger);
    }

  // Init por-wrapper
  window.__SectionRegistry['featured-collection'] = function initFeaturedCollection(wrapper) {
    if (!wrapper || wrapper.__featuredInit) return;
    wrapper.__featuredInit = true;

    function start() {
      if (!libsReady()) return setTimeout(start, 50);

      const gsap = window.gsap;
      const ScrollTrigger = window.ScrollTrigger;
      gsap.registerPlugin(ScrollTrigger);

      // Usa el mismo scroller que definiste en tu bridge Lenis<->ST (html)
      ScrollTrigger.defaults({ scroller: document.documentElement });

      ScrollTrigger.create({
        trigger: wrapper,
        start: 'top top+=200',
        end: 'bottom bottom-=200',
        onRefresh: () => {}, // solo para obligar a crear el ST
        });

      const list = wrapper.querySelector('[data-list]');
      if (!list) return;

      // Todos los items (LI) de producto
      const items = Array.from(list.querySelectorAll('.grid__item'));
      if (!items.length) return;

      // Estado inicial: invisibles
      gsap.set(items, { opacity: 0, y: 20, willChange: 'transform,opacity' });

      // Batch: entra/sale con stagger suave
      ScrollTrigger.batch(items, {
        start: 'top 85%',
        end: 'bottom 15%',
        // cuando entran hacia abajo:
        onEnter: (batch) => {
          gsap.to(batch, {
            opacity: 1,
            y: 0,
            overwrite: false,
            duration: 0.5,
            ease: 'power2.out',
            stagger: { each: 0.12, from: 'start' }
          });
        },
        // cuando vuelves a bajar y re-entran desde arriba:
        onEnterBack: (batch) => {
          gsap.to(batch, {
            opacity: 1,
            y: 0,
            overwrite: false,
            duration: 0.4,
            ease: 'power2.out',
            stagger: { each: 0.08, from: 'end' }
          });
        },
        // cuando salen por arriba al scrollear hacia arriba:
        onLeaveBack: (batch) => {
          gsap.to(batch, {
            opacity: 0,
            y: 20,
            overwrite: false,
            duration: 0.35,
            ease: 'power1.out',
            stagger: { each: 0.06, from: 'end' }
          });
        },
        // cuando salen por abajo al scrollear hacia abajo:
        onLeave: (batch) => {
          gsap.to(batch, {
            opacity: 1,
            y: 0,
            overwrite: false,
            duration: 0.35,
            ease: 'power1.out',
            stagger: { each: 0.06, from: 'start' }
          });
        },
        // rendimiento
        interval: 0.1,  // chequeo de lote
        batchMax: 6     // tamaño máximo por lote
      });

      // Cuando cargan imágenes dentro de las cards, refresca medidas
      const imgs = list.querySelectorAll('img');
      imgs.forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
        }
      });

      // Por si el tema cambia layout dinámicamente
      requestAnimationFrame(() => ScrollTrigger.refresh());

      // Limpieza si el editor reemplaza la sección
      const onUnload = (e) => {
        if (e.target && wrapper.contains(e.target)) {
          try { ScrollTrigger.getAll().forEach(st => st.kill()); } catch (_) {}
          wrapper.__featuredInit = false;
          document.removeEventListener('shopify:section:unload', onUnload);
        }
      };
      document.addEventListener('shopify:section:unload', onUnload);
    }

    start();
  };

  // Si hubo wrappers antes de cargar este archivo, procésalos ahora
  if (window.__flushSectionQueue) window.__flushSectionQueue('featured-collection');
})();